import { BellaTranslator } from '@westwing/appshell_types';
import React, { ReactElement, ReactNode } from 'react';
import { useTranslator } from 'AppShell/hooks';

interface UseTranslateReturnType {
    tPlain: BellaTranslator;
    t: (
        pokey: string,
        args?: Array<string | number>,
        plural?: boolean
    ) => React.DetailedReactHTMLElement<{}, HTMLElement>;
    tt: (strings: TemplateStringsArray, ...vars: ReactNode[]) => React.DetailedReactHTMLElement<{}, HTMLElement>;
}

export type CustomTranslator = (pokey: string, parameterValues?: Array<string | number>) => ReactElement;
const useTranslate = (): UseTranslateReturnType => {
    const translatePlain = useTranslator();

    const translate: UseTranslateReturnType['t'] = (pokey, parameterValues, plural) =>
        React.createElement('span', {
            dangerouslySetInnerHTML: { __html: translatePlain(pokey, parameterValues, plural) },
        });

    const translateTemplate: UseTranslateReturnType['tt'] = (strings, ...vars) => {
        const VAR_PLACEHOLDER = '\0\0\0';
        const pokey = strings.join('%s');
        const varsPlaceholders = Array(vars.length).fill(VAR_PLACEHOLDER);
        const translatedStrings = translatePlain(pokey, ...varsPlaceholders).split(VAR_PLACEHOLDER);

        const reactChildren: ReactNode[] = [];
        translatedStrings.forEach((str: string, index: number) => {
            reactChildren.push(str);
            if (vars[index]) {
                reactChildren.push(vars[index]);
            }
        });

        return React.createElement('span', {}, ...reactChildren);
    };

    return {
        tPlain: translatePlain,
        t: translate,
        tt: translateTemplate,
    };
};

export default useTranslate;
